import React from "react";
import { useTranslation } from "utilities/i18n";
import { useModalDispatch, DefaultModalForm } from "collections/Modal";

export const ProvisioningGuideModal: React.FC<{
  isEnabled: boolean;
}> = ({ isEnabled }) => {
  const { t } = useTranslation();
  const dispatchEvent = useModalDispatch();
  return (
    <DefaultModalForm
      title={
        isEnabled
          ? t("PROVISIONING_GUIDE_ENABLED_TITLE")
          : t("PROVISIONING_GUIDE_LINK")
      }
      onSubmit={dispatchEvent}
      name="guidemodal-notenabled"
      closeIcon={!isEnabled}
      className={isEnabled ? "pt-2" : ""}
    >
      <div className="small-text pt-1 pb-1">
        {t("PROVISIONING_GUIDE_INFO_1")}
      </div>
      <div className="small-text modal-body pt-1 pb-1 pl-1">
        <p>{t("PROVISIONING_GUIDE_INFO_2")}</p>
        <p>{t("PROVISIONING_GUIDE_INFO_3")}</p>
        <p>{t("PROVISIONING_GUIDE_INFO_4")}</p>
      </div>
      {isEnabled && (
        <div className="btn-container text-right">
          <button
            className="btn btn-primary"
            data-testid="continue"
            type="submit"
          >
            {t("CONTINUE")}
          </button>
        </div>
      )}
    </DefaultModalForm>
  );
};
